import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import DespesasEducacaoLogged from '../../../../components/auth/educacao/despesas'

function DespesasEducacaoLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Despesas da Secretaria Municipal de Educação" />
                <HeaderLogged />
                <Container>
                   <DespesasEducacaoLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default DespesasEducacaoLoggedScreen;